angular.module('directive.loading', [])

    .directive('loading', [
        '$http',
        '$timeout',
        function ($http, $timeout) {
            return {
                restrict: 'A',
                link: function (scope, elm, attrs) {
                    var watcher,
                        pending;

                    function isLoading() {
                        return $http.pendingRequests.length > 0;
                    }

                    watcher = scope.$watch(isLoading, function (v) {
                        if (!!v) {
                            return pending = $timeout(function () {
                                pending = "";
                                $(elm).show();
                            }, 31);
                        }
                        !!pending && $timeout.cancel(pending);
                        $(elm).hide();
                    });

                    scope.$on("$destroy", function () {
                        watcher();
                    })
                }
            };
        }]);